import { Model } from '@/models/Model';
export class Group extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Group';
        this.$endpoint = '/groups';
        this.$fillable = ['name', 'type', 'users', 'room', 'is_mandatory', 'project', 'sub_groups'];
    }
    async restoreGroup() {
        return await this.request('get', `${this.$endpoint}/restore?group=${this.id}`);
    }
}
